// SubHeader.js - OPTIMIZED VERSION
import React, { useState, useEffect, useMemo } from "react";
import {Search, Edit,Home,ChevronRight,Filter,AlertCircle,Trash2,Bell,User,Settings,Building2,Calendar,FileText,Plus,RefreshCw, CheckSquare,
} from "lucide-react";
import "../Style/SubHeader.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useFilterContext } from "./FilterContext";
import { BASE_URL } from "../Apis/apiConfig";
import { toast } from "react-toastify";

const routeNames = {
  "/dashboard": "Dashboard",
  "/assign-role": "Assign Role",
  "/circular-Notice": "Circular Notice",
  "/service-provider": "Service Provider",
  "/memeber-list": "Member List",
  "/member-bill-list": "Member Bill List",
  "/receipt": "Receipt",
  "/credit-note": "Credit Note",
  "/debit-note": "Debit Note",
  "/report": "Report",
  "/upload-menu": "Upload Menu",
  "/role-management": "Role Management",
  "/emergency": "Emergency",
  "/add-charges": "Charges",
  "/archive": "Archive",
  "/download-pdf": "Download Pdf",
  "/compose-notice": "Compose Notice",
  "/complaints": "Complaints",
  "/qr-page": "QR FOR VISITOR",
  "/notification": "Noc",
  "/emergency-list": "Emergency List",
  "/debit-note-society-name": "Debit Note",
  "/bill-society": "Bill Society",
  "/parking-list": "Parking",
  "/opening": "Opening",
  "/visitor": "Visitor",
  "/vouchers": "Vouchers",
  "/add-vouchers": "Add Vouchers",
  "/advance-payment": "Advance Payment",
  "/dynamic-form": "Create Bill Table",
  "/documents": "Documents",
  "/add-bank-details": "Add Bank Details",
  "/bank-details": "Bank Details",
  "/previous-year-bills": "Previous year Bills",
  "/previous-year-reciept": "Previous Year Receipt",
  "/previous-year-credit-notes" : "Previous Year Credit Notes",
  "/previous-year-debit-notes" : "Previous Year Debit Notes",
  "/previous-year-opening" : "Previous Year Opening",
  "/previous-year-advance-payment" : "Previous Year Advance Payment",
  "/currently-year-ledger": "Currently Year Ledger",
  "/financial-ledger": "Financial Ledger",
  "/pervious-year-ledger" : "Pervious Year Ledger",
  "/help-support" : "Help Support",
  "/employee-rating" : "EMPLOYEE RATING",
  "/rules": "Rules",
  "/manage-rule": "Manage Rules",
  "/welcome-management": "Upload Management",
  "/welcome-uplaod": "Welcome Content Management",
  "/chat-page": "Admin Chat",
  "/profile": "Admin profile",
  "/guide-line": "Guide Line",
  "/guideline-list": "View Guide Line",
  "/transaction": "Transaction",
  "/histroy-deleted-bill": "Deleted Record",
  "/add-interest" : "Add Interest",
  "/all-interest" : "ALL Interest",
  "/bill-master" : " Bill Master",
  "/generate-bill": "GENERATE Bill",
  "/upload-master": "Upload Master",
  "/member-interest-charges": "Member INTEREST Charges",
  "/master-receipt": "Master Receipt",
  "/society-batch-bills": "Society Bluk bill Genereter",
  "/master-ledger": "Master Ledger",
  "/old-master-data" : "OLD Master Bill Data",
  "/pending-bill-member" : "PENDING Bill",
  "/ledger-edit" : "LEDGER EDIT",
  "/ledger-details" : "Ledger Details"
};

const SubHeader = ({
  onRefresh,
  onDeleteAll,
  onDeleteSelected,
  selectedCount = 0,
  searchValue = "",
  onSearchChange,
  loading = false,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const { setFilteredData } = useFilterContext();
  const [error, setError] = useState(null);
  const [flats, setFlats] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");

  const currentPath = location.pathname;
  const pageTitle = routeNames[currentPath] || "Page";

  const token = useMemo(() => localStorage.getItem("token"), []);
  const society = useMemo(() => localStorage.getItem("society"), []);
  const showComposeButton = currentPath === "/circular-Notice";
  const showMemberControls = currentPath === "/memeber-list";

  const handleDeleteBill = async () => {
    const societyName = localStorage.getItem("society");
    const token = localStorage.getItem("token");

    if (!societyName?.trim()) {
      toast.error("Society name not found");
      return;
    }

    if (!token) {
      toast.error("Authentication token missing");
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/dynamic-table/delete-dynamic-table?societyName=${encodeURIComponent(
          societyName,
        )}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.text();
      toast.success(result);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Server error");
    }
  };

  const handleComposeClick = () => {
    navigate("/compose-notice");
  };

  const formatSocietyName = (name) => {
  if (!name) return "";
  let words = name.split(" ").map((word) => {
    if (word.toLowerCase() === "house") return "LTD"; 
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return words.join(" ");
};

  return (
    <div className="subheader-container">
      <style>
        {`
        /* Optimized SubHeader - More Compact */
        .subheader-container {
          background: white;
          border-bottom: 1px solid #e2e8f0;
          padding: 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          min-height: 50px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        }

        /* Breadcrumb - More Compact */
        .breadcrumb-container {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .breadcrumb {
          display: flex;
          align-items: center;
          list-style: none;
          padding: 0;
          margin: 0;
          gap: 6px;
        }

        .breadcrumb-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #64748b;
        }

        .breadcrumb-link {
          display: flex;
          align-items: center;
          gap: 6px;
          text-decoration: none;
          color: #64748b;
          transition: color 0.2s;
        }

        .breadcrumb-link:hover {
          color: #0d6efd;
        }

        .breadcrumb-separator {
          color: #cbd5e0;
        }

        .breadcrumb-item.active {
          color: #1e293b;
          font-weight: 500;
        }

        /* Right Side Content - Compact */
        .subheader-right {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        /* Search Container - Compact */
        .search-container {
          position: relative;
          width: 240px;
        }

        .search-input-wrapper {
          position: relative;
        }

        .search-input-wrapper svg {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          pointer-events: none;
        }

        .search-input {
          width: 100%;
          padding: 6px 10px 6px 32px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          font-size: 13px;
          background: white;
          color: #1e293b;
          transition: all 0.2s;
          height: 32px;
        }

        .search-input:focus {
          outline: none;
          border-color: #0d6efd;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
        }

        .search-input::placeholder {
          color: #94a3b8;
          font-size: 12px;
        }

        /* Action Buttons - Compact */
        .action-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          border: 1px solid transparent;
          white-space: nowrap;
          height: 32px;
        }

        .action-btn.primary {
          background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
          color: white;
          border: none;
        }

        .action-btn.primary:hover {
          opacity: 0.9;
          transform: translateY(-1px);
        }

        .action-btn.secondary {
          background: white;
          border-color: #e2e8f0;
          color: #475569;
        }

        .action-btn.secondary:hover {
          background: #f8fafc;
          border-color: #cbd5e0;
        }

        .action-btn.danger {
          background: #dc2626;
          color: white;
          border: none;
        }

        .action-btn.danger:hover {
          background: #b91c1c;
        }

        .action-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        /* Extra Page Actions */
        .extra-page-actions {
          display: flex;
          gap: 10px;
          margin-left: 12px;
        }

        .page-action-btn {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 5px 10px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          font-size: 12px;
          color: #475569;
          background: white;
          cursor: pointer;
          transition: all 0.2s;
          white-space: nowrap;
          height: 30px;
        }

        .page-action-btn:hover {
          background: #f8fafc;
          border-color: #cbd5e0;
        }

        .page-action-btn.danger {
          background: #fee2e2;
          border-color: #fecaca;
          color: #dc2626;
        }

        .page-action-btn.danger:hover {
          background: #fecaca;
        }

        /* Loading Animation */
        .spin-animation {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Responsive Design */
        @media (max-width: 1200px) {
          .action-btn span {
            display: none;
          }
          
          .action-btn {
            padding: 6px;
            width: 32px;
            justify-content: center;
          }
          
          .search-container {
            width: 200px;
          }
        }

        @media (max-width: 768px) {
          .subheader-container {
            flex-direction: column;
            align-items: stretch;
            padding: 12px 16px;
          }
          
          .subheader-right {
            flex-wrap: wrap;
            width: 100%;
          }
          
          .search-container {
            width: 100%;
          }
        }
        `}
      </style>
      <div className="breadcrumb-container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard" className="breadcrumb-link">
               <Home size={14} color="#007BFF" />
              <span style={{ color: "#007BFF" }}>Home</span>
              </Link>
            </li>
            <li className="breadcrumb-separator">
              <ChevronRight size={14} />
            </li>
              <li
                className="breadcrumb-item active"
                 aria-current="page"
                style={{ color: "#007BFF" }}
             >
            {pageTitle}
          </li>
          </ol>
        </nav>
        <div className="extra-page-actions">
          {location.pathname === "/upload-menu" && (
            <>
              <button
                className="page-action-btn"
                onClick={() => navigate("/dynamic-form")}
                title="Create Bill Table"
              >
                <Plus size={12} />
                <span>Create Table</span>
              </button>
              <button
                className="page-action-btn danger"
                onClick={handleDeleteBill}
                title="Delete Table"
              >
                <Trash2 size={12} />
                <span>Remove Table</span>
              </button>
            </>
          )}
        </div>
      </div>
       {location.pathname === "/rules" && (
            <>
              <button
      onClick={() => navigate("/manage-rule")}
      style={{
        padding: "10px 15px",
        backgroundColor: "#1e88e5",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
      }}
    >
      Manage Rules
    </button>
            </>
          )}
        
      <div className="subheader-right">
        {/* Compose Notice Button */}
        {showComposeButton && (
        <button
          onClick={handleComposeClick}
          aria-label="Compose new notice"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 16px",
            backgroundColor: "#2563eb",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            transition: "all 0.2s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#1e40af")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#2563eb")
          }
        >
    <Edit size={14} color="#ffffff" />
    <span>Compose</span>
  </button>
)}
        {showMemberControls && (
          <>
            {/* Search Input - Compact */}
            <input
              type="text"
              placeholder="Search members..."
              value={searchValue}
              onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
              className="search-input border-none"
            />

            {/* Action Buttons - Compact */}
            <button
              className="rounded border-none flex bg-blue-300 text-white hover:bg-blue-700 p-2 secondary"
              onClick={onRefresh}
              disabled={loading}
              title="Refresh member list"
            >
              <RefreshCw
                size={14}
                className={loading ? "spin-animation" : ""}
              />
            </button>

            <button
              className="rounded border-none flex align-center bg-red-300 text-white hover:bg-red-500 p-2 secondary danger"
              onClick={onDeleteAll}
              title="Delete all members"
            >
              <Trash2 size={14} />
              {/* <span>All</span> */}
            </button>

            <button
              className="rounded border-none gap-2 flex items-center text-left bg-red-300 text-white hover:bg-red-500 px-2 py-1 secondary danger"
              onClick={onDeleteSelected}
              disabled={selectedCount === 0}
              title={`Delete ${selectedCount} selected member(s)`}
            >
              <Trash2 size={14} />
              <span>{selectedCount}</span>
              <CheckSquare size={14} />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SubHeader;
